
import React, { useState, useEffect } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import {Link} from 'react-router-dom';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function Home() {

  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, []);

  




    return (
        <>
        <Header/>
        <div className="ot-hero-wrapper hero-1 hero-4">
          <div
            className="hero-slider ot-carousel"
            data-fade="true"
            data-adaptive-height="true"
          >


             <Carousel responsive={responsive} autoPlay infinite={true}  removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}  showDots={true}  swipeable={true}>
            
                  <div><img src="assets/img/hero/hero.png" alt="" /></div> 
                  <div><img src="assets/img/hero/hero2.png" alt="" /></div> 
                  <div><img src="assets/img/hero/hero3.png" alt="" /></div>  
                    </Carousel>


            {/* <img src="assets/img/hero/hero.png" /> */}
            {/* <div className="ot-hero-slide">
              <div style={{backgroundImage:"url(" + "assets/img/hero/hero.png" + ")", backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize:'cover'}}
                className="ot-hero-bg"
              />
              <div className="container z-index-common">
                <div className="hero-style1">
                  <div className="text-video-btn">
                    <span
                      className="bg-text"
                      data-bg-src="assets/img/bg/text_bg_2.svg"
                    />{" "}
                    <img src="assets/img/icon/counter_card_3.svg" alt="icon" />
                  </div>
                  <span
                    className="hero-subtitle"
                    data-ani="slideinup"
                    data-ani-delay="0.0s"
                  >
                    100% Quality Products
                  </span>
                  <h1 className="hero-title">
                 Shvetdhara – From Our Farmers to Your Family

                  </h1>
                  <div
                    className="btn-group"
                    data-ani="slideinup"
                    data-ani-delay="0.7s"
                  >
                   
                    <Link to="/contact" className="ot-btn style4">
                      Contact Us
                      <i className="fas fa-chevrons-right ms-2" />
                    </Link>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <section className="feature-sec1">
          <div className="container">
            <div className="row gy-4 justify-content-center">
              <div className="col-xl-4 col-sm-6">
                <div
                  className="feature-card d-block"
                  data-bg-src="assets/img/bg/clean-water.png"
                >
                  <div className="box-icon mb-2">
                    <img src="assets/img/icon/Putity.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Purity & Freshness</h3>
                    <p>Every drop of milk is tested for purity and freshness, ensuring you get nature's best in every glass.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-6">
                <div
                  className="feature-card d-block"
                  data-bg-src="assets/img/bg/feature_card_bg.png"
                >
                  <div className="box-icon mb-2">
                    <img src="assets/img/icon/community.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Community First</h3>
                    <p>Supporting local farmers with fair prices and sustainable practices that benefit entire communities.</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-sm-6">
                <div
                  className="feature-card d-block"
                  data-bg-src="assets/img/bg/feature_card_bg.png"
                >
                  <div className="box-icon mb-2">
                    <img src="assets/img/icon/premium.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Premium Quality</h3>
                    <p>Rigorous quality control and traditional methods ensure the highest standards in every product.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="space">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-7 mb-40 mb-xl-0">
                <div className="img-box1">
                  <img src="assets/img/normal/cow-farm.png" alt="About" style={{width:'100%'}} />
                </div>
              </div>
              <div className="col-xl-5 text-center text-xl-start">
                <div className="title-area mb-34">
                  <span className="sub-title">
                    <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                    About Company
                  </span>
                  <h2 className="sec-title">
                  We promise for better health with better taste

                  </h2>
                  <p className="sec-desc">
                 Since 2002, our dairy brand has worked closely with local Indian farmers to bring the freshest, purest milk and dairy products directly to your home.

Mr. Sandeep, the Director of Shvetdhara started his journey as the retailer of milk products in 13, June 2002. This initiative played a significant role that inspired him to start a dairy product plant of his own. Later in 2009, he installed his own setup of Paneer Plant as “New Kamboj Dairy” which proved to be a great success. This plant infused employment and growth in the private sector.


                  </p>
                </div>
                <div className="mb-40">
                  <div className="about-feature-wrap">
                    <div className="about-feature">
                      <div className="box-icon">
                        <img src="assets/img/icon/about_feature_1.svg" alt="Icon" />
                      </div>
                      <h3 className="box-title">100% Pure Products</h3>
                    </div>
                    <div className="about-feature">
                      <div className="box-icon">
                        <img src="assets/img/icon/about_feature_2.svg" alt="Icon" />
                      </div>
                      <h3 className="box-title">100% Quality Products</h3>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
        {/* <section
          className="bg-smoke2 space"
          data-bg-src="assets/img/bg/service_bg_1.png"
        >
          <div className="container">
            <div className="row justify-content-md-between justify-content-center align-items-end">
              <div className="col-md-8 mb-n2 mb-md-0">
                <div className="title-area text-center text-md-start">
                  <span className="sub-title">
                    <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                    Popular Services
                  </span>
                  <h2 className="sec-title">We Offer best services</h2>
                  <p>At Shvetdhara, we ensure that every drop of milk we produce is packed with nutritional goodness and love. Our strict quality control measures and innovative processing techniques preserve the natural flavor and nutritional content of our dairy products. With Shvetdhara, you’re choosing unmatched quality and freshness.

</p>
                </div>
              </div>
              <div className="col-auto">
                <div className="sec-btn">
                  <div className="icon-box">
                    <button
                      data-slick-prev="#serviceSlider1"
                      className="slick-arrow default"
                    >
                      <i className="far fa-chevrons-left" />
                    </button>{" "}
                    <button
                      data-slick-next="#serviceSlider1"
                      className="slick-arrow default"
                    >
                      <i className="far fa-chevrons-right" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div
              className="row slider-shadow ot-carousel"
              id="serviceSlider1"
              data-slide-show={4}
              data-lg-slide-show={3}
              data-md-slide-show={2}
              data-sm-slide-show={2}
              data-focuson-select="false"
            >
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="service-card">
                  <div className="box-img">
                    <img
                      src="assets/img/service/service_card_1.jpg"
                      alt="service image"
                    />
                  </div>
                  <div className="box-content">
                    <div
                      className="shape"
                      data-bg-src="assets/img/bg/service_card_bg.png"
                    />
                    <div
                      className="box-icon"
                      data-bg-src="assets/img/icon/service_card_icon.svg"
                    >
                      <img src="assets/img/icon/service_card_1.svg" alt="Icon" />
                    </div>
                    <h3 className="box-title">
                    Strict Quality Control
                    </h3>
                    <p className="box-text">
                    We follow rigorous quality checks to ensure consistency in taste and nutritional value.


                    </p>
                   
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="service-card">
                  <div className="box-img">
                    <img
                      src="assets/img/service/service_card_2.jpg"
                      alt="service image"
                    />
                  </div>
                  <div className="box-content">
                    <div
                      className="shape"
                      data-bg-src="assets/img/bg/service_card_bg.png"
                    />
                    <div
                      className="box-icon"
                      data-bg-src="assets/img/icon/service_card_icon.svg"
                    >
                      <img src="assets/img/icon/service_card_2.svg" alt="Icon" />
                    </div>
                    <h3 className="box-title">
                    Innovation & Sustainability

                    </h3>
                    <p className="box-text">
                    We blend traditional practices with modern innovations to produce environmentally friendly dairy products.


                    </p>
                 
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="service-card">
                  <div className="box-img">
                    <img
                      src="assets/img/service/service_card_3.jpg"
                      alt="service image"
                    />
                  </div>
                  <div className="box-content">
                    <div
                      className="shape"
                      data-bg-src="assets/img/bg/service_card_bg.png"
                    />
                    <div
                      className="box-icon"
                      data-bg-src="assets/img/icon/service_card_icon.svg"
                    >
                      <img src="assets/img/icon/service_card_3.svg" alt="Icon" />
                    </div>
                    <h3 className="box-title">
                    100% Fresh & Pure

                    </h3>
                    <p className="box-text">
                    Every Gaj product is guaranteed to be fresh and free from harmful preservatives.


                    </p>
                    
                </div>
              </div>
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="service-card">
                  <div className="box-img">
                    <img
                      src="assets/img/service/service_card_4.jpg"
                      alt="service image"
                    />
                  </div>
                  <div className="box-content">
                    <div
                      className="shape"
                      data-bg-src="assets/img/bg/service_card_bg.png"
                    />
                    <div
                      className="box-icon"
                      data-bg-src="assets/img/icon/service_card_icon.svg"
                    >
                      <img src="assets/img/icon/service_card_4.svg" alt="Icon" />
                    </div>
                    <h3 className="box-title">
                    Wide Product Range

                    </h3>
                    <p className="box-text">
                    From milk to ghee, paneer, and more, we cater to all your dairy needs.


                    </p>
                    
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </section> */}
        <section className="space">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                Why Choose Shvetdhara?

              </span>
              <h2 className="sec-title">Easy our 4 step work</h2>
            </div>
            <div className="process-card-wrap">
              <div className="process-card">
                <div className="box-number">01</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_1.svg" alt="Icon" />
                </div>
                <h3 className="box-title">Strict Quality Control
                </h3>
              
              </div>
              <div className="process-card">
                <div className="box-number">02</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_2.svg" alt="Icon" />
                </div>
                <h3 className="box-title">Innovation & Sustainability
                </h3>
                
              </div>
              <div className="process-card">
                <div className="box-number">03</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_3.svg" alt="Icon" />
                </div>
                <h3 className="box-title">100% Fresh & Pure
                </h3>
             
              </div>
              <div className="process-card">
                <div className="box-number">04</div>
                <div className="box-icon">
                  <img src="assets/img/icon/process_card_4.svg" alt="Icon" />
                </div>
                <h3 className="box-title">Wide Product Range
                </h3>
              
              </div>
            </div>
          </div>
        </section>


      
  <section style={{backgroundImage:"url(" + "assets/img/bg/service_bg_2.png" + ")", backgroundRepeat:'no-repeat', backgroundSize:'cover'}}
    className="bg-smoke2 space"
  >
    <div className="container">
      <div className="row justify-content-md-between justify-content-center align-items-end">
        <div className="col-md-8 mb-n2 mb-md-0">
          <div className="title-area text-center text-md-start">
            <span className="sub-title">
              <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
              What we offer
            </span>
            <h2 className="sec-title">We Offer Best Products</h2>
          </div>
        </div>
       
      </div>
      <div
        className="row slider-shadow ot-carousel"
      >
        <div className="col-sm-6 col-lg-4 col-xl-3">
      
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/rabri/18.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
                    Rabri-100gm
              </h3>
              <span className="price">₹35</span>
            </div>
          </div>
          </div>
        </div>


        <div className="col-sm-6 col-lg-4 col-xl-3">
              
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/chaanch/19.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Masala Chhach-300 ML
              </h3>
              <span className="price">₹14</span>
            </div>
          </div>
          </div>
        </div>
       

        <div className="col-sm-6 col-lg-4 col-xl-3">
         
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dahi/20.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Fresh Curd-500 Gm     </h3>
              <span className="price">₹45</span>
            </div>
          </div>
          </div>


        </div>

        <div className="col-sm-6 col-lg-4 col-xl-3">
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dahi/21.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Standard Milk 6Ltr     </h3>
              <span className="price">₹396</span>
            </div>
          </div>
          </div>

        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
             <div className="btn-group" style={{width:'100%', padding:'50px 0px 0px'}}>
         <Link to="/products" className="ot-btn style4">
                      More Products
                      <i className="fas fa-chevrons-right ms-2" />
                    </Link></div></div>
      </div>
    </div>
  </section>
  <section className="" style={{backgroundImage:"url(" + "assets/img/bg/cta_bg_1.png" + ")", backgroundRepeat:'no-repeat'}}>
    <div className="container text-center space">
      <div className="row justify-content-center">
        <div className="col-xxl-9 col-lg-10">
          <h2 className="fs-60 sec-title text-white">
          Discover Services Come & Feel Our Dairy

          </h2>
          
          <div className="btn-group">
           
          <Link to="/contact" className="ot-btn style4">
                      Contact Us
                      <i className="fas fa-chevrons-right ms-2" />
                    </Link>
          </div>
        </div>
      </div>
    </div>
  </section>

        {/* <section className="space">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                Customer Feedback
              </span>
              <h2 className="sec-title">What our Customer say</h2>
            </div>
            <div
              className="row ot-carousel"
              id="testiSlide1"
              data-slide-show={3}
              data-lg-slide-show={2}
              data-md-slide-show={2}
              data-sm-slide-show={1}
              data-dots="true"
            >
              <div className="col-lg-6">
                <div
                  className="testi-card"
                  data-bg-src="assets/img/bg/testi_card_bg.png"
                >
                  <div className="box-quote">
                    <svg
                      width={81}
                      height={70}
                      viewBox="0 0 81 70"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M69.4285 34H47.2856V1H80V35C80 53.418 65.4081 68.4501 47.2856 68.9853V59.3127C60.1438 58.7824 70.4285 48.0731 70.4285 35V34H69.4285Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                      <path
                        d="M23.1428 34H1V1H33.7144V35C33.7144 53.418 19.1225 68.4501 1 68.9853V59.3127C13.8581 58.7824 24.1428 48.0731 24.1428 35V34H23.1428Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                    </svg>
                  </div>
                  <div className="box-img">
                    <img src="assets/img/testimonial/testi_1_1.jpg" alt="Avater" />
                  </div>
                  <h3 className="box-title">Harold Marlin</h3>
                  <p className="box-desig">CEO of Farmery</p>
                  <p className="box-text">
                    This website is a fantastic resource for both novice and
                    experienced farmers and organic fresh food
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="testi-card"
                  data-bg-src="assets/img/bg/testi_card_bg.png"
                >
                  <div className="box-quote">
                    <svg
                      width={81}
                      height={70}
                      viewBox="0 0 81 70"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M69.4285 34H47.2856V1H80V35C80 53.418 65.4081 68.4501 47.2856 68.9853V59.3127C60.1438 58.7824 70.4285 48.0731 70.4285 35V34H69.4285Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                      <path
                        d="M23.1428 34H1V1H33.7144V35C33.7144 53.418 19.1225 68.4501 1 68.9853V59.3127C13.8581 58.7824 24.1428 48.0731 24.1428 35V34H23.1428Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                    </svg>
                  </div>
                  <div className="box-img">
                    <img src="assets/img/testimonial/testi_1_2.jpg" alt="Avater" />
                  </div>
                  <h3 className="box-title">Angela Janet</h3>
                  <p className="box-desig">Senior Farmer</p>
                  <p className="box-text">
                    I love the user-friendly interface of this agriculture site. It is
                    easy to navigate and get products from store.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="testi-card"
                  data-bg-src="assets/img/bg/testi_card_bg.png"
                >
                  <div className="box-quote">
                    <svg
                      width={81}
                      height={70}
                      viewBox="0 0 81 70"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M69.4285 34H47.2856V1H80V35C80 53.418 65.4081 68.4501 47.2856 68.9853V59.3127C60.1438 58.7824 70.4285 48.0731 70.4285 35V34H69.4285Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                      <path
                        d="M23.1428 34H1V1H33.7144V35C33.7144 53.418 19.1225 68.4501 1 68.9853V59.3127C13.8581 58.7824 24.1428 48.0731 24.1428 35V34H23.1428Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                    </svg>
                  </div>
                  <div className="box-img">
                    <img src="assets/img/testimonial/testi_1_3.jpg" alt="Avater" />
                  </div>
                  <h3 className="box-title">Ricardo Adrian</h3>
                  <p className="box-desig">CEO at Organo</p>
                  <p className="box-text">
                    This agriculture website stands out for its commitment to
                    environmental sustainability for good health.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="testi-card"
                  data-bg-src="assets/img/bg/testi_card_bg.png"
                >
                  <div className="box-quote">
                    <svg
                      width={81}
                      height={70}
                      viewBox="0 0 81 70"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M69.4285 34H47.2856V1H80V35C80 53.418 65.4081 68.4501 47.2856 68.9853V59.3127C60.1438 58.7824 70.4285 48.0731 70.4285 35V34H69.4285Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                      <path
                        d="M23.1428 34H1V1H33.7144V35C33.7144 53.418 19.1225 68.4501 1 68.9853V59.3127C13.8581 58.7824 24.1428 48.0731 24.1428 35V34H23.1428Z"
                        stroke="#4AA760"
                        strokeWidth={2}
                      />
                    </svg>
                  </div>
                  <div className="box-img">
                    <img src="assets/img/testimonial/testi_1_4.jpg" alt="Avater" />
                  </div>
                  <h3 className="box-title">David Anarson</h3>
                  <p className="box-desig">CEO at Seedon</p>
                  <p className="box-text">
                    The community forum on this site is a valuable feature. It allows
                    farmers to connect business very easy way.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="video-sec1" data-bg-src="assets/img/bg/video_bg_1.png">
          <div className="container text-center space">
            <div className="mb-5 pt-4">
              <a
                href="https://www.youtube.com/watch?v=_sI_Ps7JSEk"
                className="play-btn popup-video"
              >
                <i className="fas fa-play" />
              </a>
            </div>
            <h2 className="fs-60 sec-title text-white mb-n2">
              Farming today for a greener healthier World tomorrow.
            </h2>
          </div>
        </section> */}
        {/* <div className="counter-sec1">
          <div className="container">
            <div
              className="counter-card-wrap"
              data-bg-src="assets/img/bg/counter_bg_1.png"
            >
              <div className="counter-card">
                <div
                  className="box-icon"
                  data-bg-src="assets/img/bg/counter_card_bg.svg"
                >
                  <img src="assets/img/icon/counter_card_1.svg" alt="icon" />
                </div>
                <div className="media-body">
                  <h2 className="box-number">
                    <span className="counter-number">25.8</span>K
                  </h2>
                  <p className="box-text">Project Completed</p>
                </div>
              </div>
              <div className="counter-card">
                <div
                  className="box-icon"
                  data-bg-src="assets/img/bg/counter_card_bg.svg"
                >
                  <img src="assets/img/icon/counter_card_2.svg" alt="icon" />
                </div>
                <div className="media-body">
                  <h2 className="box-number">
                    <span className="counter-number">920</span>+
                  </h2>
                  <p className="box-text">Export Farmers</p>
                </div>
              </div>
              <div className="counter-card">
                <div
                  className="box-icon"
                  data-bg-src="assets/img/bg/counter_card_bg.svg"
                >
                  <img src="assets/img/icon/counter_card_3.svg" alt="icon" />
                </div>
                <div className="media-body">
                  <h2 className="box-number">
                    <span className="counter-number">80</span>+
                  </h2>
                  <p className="box-text">Winning Award</p>
                </div>
              </div>
              <div className="counter-card">
                <div
                  className="box-icon"
                  data-bg-src="assets/img/bg/counter_card_bg.svg"
                >
                  <img src="assets/img/icon/counter_card_4.svg" alt="icon" />
                </div>
                <div className="media-body">
                  <h2 className="box-number">
                    <span className="counter-number">12.2</span>k
                  </h2>
                  <p className="box-text">Customer Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <section className="space" id="blog-sec">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="assets/img/theme-img/subtitle_icon.svg" alt="icon" />
                Blog &amp; News
              </span>
              <h2 className="sec-title">Latest News &amp; Blog</h2>
            </div>
            <div
              className="row ot-carousel"
              data-slide-show={3}
              data-lg-slide-show={2}
              data-md-slide-show={2}
              data-sm-slide-show={1}
              data-arrows="true"
            >
              <div className="col-md-6 col-xl-4">
                <div className="blog-box">
                  <div className="blog-img">
                    <img src="assets/img/blog/blog_1_1.jpg" alt="blog image" />{" "}
                    <a className="date" href="blog.html">
                      <span>15</span>Jan
                    </a>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <a href="blog.html">
                        <i className="fas fa-tags" /> Fruits
                      </a>{" "}
                      <a href="blog.html">
                        <i className="fas fa-comments" /> 3 Comments
                      </a>
                    </div>
                    <h3 className="blog-title box-title">
                      <a href="blog-details.html">
                        Pure and Fresh Natural Fruit for a Healthy Life
                      </a>
                    </h3>
                    <p className="box-text">
                      Fusce lobortis lacus. Mauris consequat, diam a accumsan
                      ullamcorper
                    </p>
                    <div className="box-bottom">
                      <a href="blog-details.html" className="link-btn">
                        Read More
                        <i className="fas fa-chevrons-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4">
                <div className="blog-box">
                  <div className="blog-img">
                    <img src="assets/img/blog/blog_1_2.jpg" alt="blog image" />{" "}
                    <a className="date" href="blog.html">
                      <span>16</span>Jan
                    </a>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <a href="blog.html">
                        <i className="fas fa-tags" /> Gardening
                      </a>{" "}
                      <a href="blog.html">
                        <i className="fas fa-comments" /> 3 Comments
                      </a>
                    </div>
                    <h3 className="blog-title box-title">
                      <a href="blog-details.html">
                        Fueling a Healthy Life with Pure and Fresh Fruits
                      </a>
                    </h3>
                    <p className="box-text">
                      Fusce lobortis lacus. Mauris consequat, diam a accumsan
                      ullamcorper
                    </p>
                    <div className="box-bottom">
                      <a href="blog-details.html" className="link-btn">
                        Read More
                        <i className="fas fa-chevrons-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4">
                <div className="blog-box">
                  <div className="blog-img">
                    <img src="assets/img/blog/blog_1_3.jpg" alt="blog image" />{" "}
                    <a className="date" href="blog.html">
                      <span>17</span>Jan
                    </a>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <a href="blog.html">
                        <i className="fas fa-tags" /> Farming
                      </a>{" "}
                      <a href="blog.html">
                        <i className="fas fa-comments" /> 3 Comments
                      </a>
                    </div>
                    <h3 className="blog-title box-title">
                      <a href="blog-details.html">
                        Improve Your Health by Fresh Organic Vegetable
                      </a>
                    </h3>
                    <p className="box-text">
                      Fusce lobortis lacus. Mauris consequat, diam a accumsan
                      ullamcorper
                    </p>
                    <div className="box-bottom">
                      <a href="blog-details.html" className="link-btn">
                        Read More
                        <i className="fas fa-chevrons-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4">
                <div className="blog-box">
                  <div className="blog-img">
                    <img src="assets/img/blog/blog_1_4.jpg" alt="blog image" />{" "}
                    <a className="date" href="blog.html">
                      <span>18</span>Jan
                    </a>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <a href="blog.html">
                        <i className="fas fa-tags" /> Organic
                      </a>{" "}
                      <a href="blog.html">
                        <i className="fas fa-comments" /> 3 Comments
                      </a>
                    </div>
                    <h3 className="blog-title box-title">
                      <a href="blog-details.html">
                        The Best Path to Health Pure and Organic Foods
                      </a>
                    </h3>
                    <p className="box-text">
                      Fusce lobortis lacus. Mauris consequat, diam a accumsan
                      ullamcorper
                    </p>
                    <div className="box-bottom">
                      <a href="blog-details.html" className="link-btn">
                        Read More
                        <i className="fas fa-chevrons-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section
          className="newsletter-sec1 bg-theme"
          data-bg-src="assets/img/bg/subscribe_bg_1.png"
        >
          <div className="container">
            <div className="newsletter-wrap">
              <h3 className="sec-title newsletter-title">
                Subscribe Our Newsletter Get Update
              </h3>
              <form className="newsletter-form">
                <div className="form-group">
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Email Address"
                    required=""
                  />
                </div>
                <button type="submit" className="ot-btn style4">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </section> */}

        <Footer />
      </>
      
    );
  }
  
  export default Home;
  